import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {
    DocumentoMuestraLaboratorioSolicitudViewModel,
    EnvioMuestrasLaboratorioSolicitudInspectorViewModel,
    MotivoMuestraLaboratorioSolicitudViewModel,
    MotivoMuestraLaboratorioViewModel,
    ResultadoEnvioMuestraLaboratorioViewModel,
    SolicitudLaboratorioViewModel,
    TwResultadoEnvioMuestraLaboratorioSolicitudViewModel,
} from './laboratorio.types';
import { DocumentModule, UploadedFileViewModel } from '../../../core/components/uploader/document_uploader.types';
import { DocumentUploaderService } from '../../../core/components/uploader/document-uploader.service';

@Injectable()
export class LaboratorioService {
    private fileEndpoint = this.baseUrl + 'api/core/labdoc/';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private uploaderService: DocumentUploaderService,
    ) {}

    getSolicitudLaboratorio(id: number): Observable<SolicitudLaboratorioViewModel> {
        return this.http.get<SolicitudLaboratorioViewModel>(this.baseUrl + 'api/importacion/Laboratorio/' + id).pipe();
    }

    getMotivosMuestraLaboratorio(): Observable<MotivoMuestraLaboratorioViewModel[]> {
        return this.http.get<MotivoMuestraLaboratorioViewModel[]>(this.baseUrl + 'api/importacion/Laboratorio/AllMotivosMuestra').pipe();
    }

    getResultadosMuestraLaboratorio(): Observable<ResultadoEnvioMuestraLaboratorioViewModel[]> {
        return this.http.get<ResultadoEnvioMuestraLaboratorioViewModel[]>(this.baseUrl + 'api/importacion/Laboratorio/AllResultadosMuestra').pipe();
    }

    saveInspectorEnvioMuestras(model: EnvioMuestrasLaboratorioSolicitudInspectorViewModel): Observable<any> {
        return this.http.post<EnvioMuestrasLaboratorioSolicitudInspectorViewModel>(this.baseUrl + 'api/importacion/Laboratorio/InspectorEnvioMuestras', model);
    }

    getMotivosMuestraLaboratorioByIdSolicitud(idSolicitud: number): Observable<MotivoMuestraLaboratorioSolicitudViewModel[]> {
        return this.http
            .get<MotivoMuestraLaboratorioSolicitudViewModel[]>(this.baseUrl + 'api/importacion/Laboratorio/MotivosMuestrasByIdSolicitud/' + idSolicitud)
            .pipe();
    }

    saveResultadoEnvioMuestrasLaboratorio(model: TwResultadoEnvioMuestraLaboratorioSolicitudViewModel): Observable<any> {
        return this.http.put<TwResultadoEnvioMuestraLaboratorioSolicitudViewModel>(
            this.baseUrl + 'api/importacion/Laboratorio/ResultadoEnvioMuestrasLaboratorio',
            model,
        );
    }

    getDocumentosLaboratorio(idSolicitud: number): Observable<DocumentoMuestraLaboratorioSolicitudViewModel[]> {
        return this.http.get<DocumentoMuestraLaboratorioSolicitudViewModel[]>(
            this.baseUrl + 'api/importacion/Laboratorio/GetDocumentosLaboratorio/' + idSolicitud,
        );
    }

    persist(documentoLaboratorio: DocumentoMuestraLaboratorioSolicitudViewModel): Observable<any> {
        if (documentoLaboratorio) {
            return this.http.post<DocumentoMuestraLaboratorioSolicitudViewModel>(
                this.baseUrl + 'api/importacion/Laboratorio/persistDocumentoMuestraLaboratorio',
                documentoLaboratorio,
            );
        }
        return of(null);
    }

    deleteDocumentosLaboratorio(id: number): Observable<any> {
        return this.http
            .delete<DocumentoMuestraLaboratorioSolicitudViewModel>(this.baseUrl + 'api/importacion/Laboratorio/DocumentoMuestraLaboratorio/' + id)
            .pipe();
    }

    getDocumentoLaboratorio(id: number): Observable<DocumentoMuestraLaboratorioSolicitudViewModel> {
        return this.http.get<DocumentoMuestraLaboratorioSolicitudViewModel>(this.baseUrl + 'api/importacion/Laboratorio/GetDocumentoLaboratorio/' + id);
    }

    download(file: DocumentoMuestraLaboratorioSolicitudViewModel): Observable<HttpResponse<Blob>> {
        const uploadedFile = new UploadedFileViewModel();
        uploadedFile.Guid = file.CodigoStorage;
        uploadedFile.Name = file.NombreArchivo;
        uploadedFile.Size = file.Size;
        delete uploadedFile.OldGuidCollection;
        delete uploadedFile.MarkToDelete;
        delete uploadedFile.Progress;

        return this.uploaderService.download(uploadedFile, DocumentModule.Laboratorio);
    }

    deleteFile(guid: string): Observable<any> {
        return this.http.delete<string>(this.fileEndpoint + guid);
    }
}
